export default class TabTimer {
    constructor(container) {
        // Scope all selectors to the container
        this.container = container;
        this.timerTabs = container.querySelector('.timer-tabs');
        this.tabContent = container.querySelector('.tabs-container .tab-content');
        this.startButton = container.querySelector('.tabs-container button');

        // Instance-specific state
        this.interval = null;
        this.initialized = false;
        this.isManuallyPaused = false;
        this.isAnimationStopped = false;

        if (!this.timerTabs || !this.tabContent || !this.startButton) return;

        this.init();
    }

    init() {
        this.setupObserver();
        this.bindEvents();
    }

    setInitialState() {
        this.timerTabs.children[0].classList.add('active');
        const firstContent = this.container.querySelector('.tab-content > div');
        if (firstContent) {
            firstContent.classList.add('active');
            this.tabContent.style.height = `${firstContent.offsetHeight}px`;
        }
    }

    loop = () => {
        if (this.isAnimationStopped) return;

        const activeTab = this.timerTabs.querySelector('.active');
        const activeContent = this.container.querySelector('.tab-content .active');
        if (!activeTab || activeTab.classList.contains('paused')) return;

        const next = activeTab.nextElementSibling || this.timerTabs.children[0];
        next === this.timerTabs.children[0] && next.classList.remove('reset');

        this.updateTab(activeTab, next);
        this.updateContent(activeContent);
    }

    updateTab(activeTab, nextTab) {
        activeTab.classList.remove('active');
        nextTab.classList.add('active');
        this.timerTabs.scrollTo({ left: nextTab.offsetLeft, behavior: 'smooth' });
    }

    updateContent(activeContent) {
        const nextContent = activeContent?.nextElementSibling ||
            this.container.querySelector('.tab-content > div');

        if (activeContent && nextContent) {
            activeContent.classList.remove('active');
            nextContent.classList.add('active');
            this.tabContent.style.height = `${nextContent.offsetHeight}px`;
        }
    }

    setupObserver() {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !this.initialized) {
                    this.setInitialState();
                    this.initialized = true;
                }

                if (entry.isIntersecting && !this.isManuallyPaused) {
                    this.isAnimationStopped = false;
                    !this.interval && (this.interval = setInterval(this.loop, 10000));
                } else {
                    this.isAnimationStopped = true;
                    this.clearTimer();
                }
            });
        }, { threshold: 0.1 });

        observer.observe(this.startButton);
    }

    handleClick = e => {
        const button = e.target.closest('button');
        if (!button) return;

        this.isAnimationStopped = true;
        this.isManuallyPaused = true;
        this.clearTimer();

        const tab = button.parentElement;
        if (!tab || tab.classList.contains('active')) return;

        const tabIndex = Array.from(this.timerTabs.children).indexOf(tab);
        this.updateTabOnClick(tab, button, tabIndex);
    }

    updateTabOnClick(tab, button, index) {
        this.timerTabs.querySelector('.active')?.classList.remove('active');
        tab.classList.add('active');
        button.querySelector('.progress')?.style.setProperty('background', '#000');

        const tabContents = this.container.querySelectorAll('.tab-content > div');
        tabContents.forEach(content => content.classList.remove('active'));

        if (tabContents[index]) {
            tabContents[index].classList.add('active');
            this.tabContent.style.height = `${tabContents[index].offsetHeight}px`;
        }
    }

    clearTimer() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }

    bindEvents() {
        this.timerTabs.addEventListener('click', this.handleClick);
    }

    // Clean up method for removing observers and events if needed
    destroy() {
        this.clearTimer();
        this.timerTabs.removeEventListener('click', this.handleClick);
    }
}